(function () {
  const formatWithDelimiters = (amount, precision, thousands, decimal) => {
    const number = Number(amount);
    if (Number.isNaN(number) || number === null) return '0';

    const fixed = number.toFixed(precision);
    const parts = fixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? `${decimal}${parts[1]}` : '';
    return `${dollars}${cents}`;
  };

  // Minimal Shopify.money_format compatible formatter
  const formatMoneyFallback = (cents, moneyFormat) => {
    const formatString = moneyFormat || '${{amount}}';
    const value = Number(cents) || 0;

    const placeholderMatch = formatString.match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

    let formatted = '';
    switch (placeholder) {
      case 'amount':
        formatted = formatWithDelimiters(value / 100, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value / 100, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value / 100, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value / 100, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(value / 100, 2, "'", '.');
        break;
      default:
        formatted = formatWithDelimiters(value / 100, 2, ',', '.');
        break;
    }

    return formatString.replace(placeholderMatch ? placeholderMatch[0] : '{{amount}}', formatted);
  };

  const formatMoney = (cents, moneyFormat) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {
      // ignore
    }

    return formatMoneyFallback(cents, moneyFormat);
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });
    if (!res.ok) throw new Error('cart_fetch_failed');
    return res.json();
  };

  const init = () => {
    const bar = document.querySelector('[data-mobile-floating-cart]');
    if (!bar) return;

    const totalEl = bar.querySelector('[data-mobile-floating-cart-total]');
    const checkoutEl = bar.querySelector('[data-mobile-floating-cart-checkout]');
    const moneyFormat = bar.getAttribute('data-money-format') || '${{amount}}';

    const setVisible = (visible) => {
      // Always visible on first load (and after) per spec
      bar.removeAttribute('hidden');
      document.body.classList.add('has-mobile-floating-cart');
    };

    const render = (cart) => {
      if (!cart) return;
      setVisible(true);

      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price, moneyFormat);
      }
    };

    const refresh = () => {
      return fetchCart()
        .then(render)
        .catch(() => {});
    };

    // Clicking bar opens drawer; checkout button should not.
    bar.addEventListener('click', (e) => {
      if (checkoutEl && (e.target === checkoutEl || checkoutEl.contains(e.target))) return;

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
    });

    // Prevent navigation inside cart drawer (mobile): only allow +/- and checkout.
    document.addEventListener(
      'click',
      (e) => {
        if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
        const link = e.target && e.target.closest && e.target.closest('cart-drawer a.cart-item__name, cart-drawer a.cart-item__link');
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    // Keep in sync with Dawn cart events
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => refresh());
    }

    // Keep in sync with custom events (fallback)
    window.addEventListener('mobile-floating-cart:refresh', () => refresh());

    refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
